angular.module('bribac.values', [])

  // Use a constant so the object can't be changed so that we can always expect
  // the same object, since we'll be mutating that object instead creating new
  // ones.
  .constant('state', {})

  // Put 'production' or 'korea' here
  .constant('VARIANT', 'production')
    // this describes the flavour of the application, possible values: 'AIT', 'EU'
    .constant('FLAVOUR', 'EU')

  .constant('API_BASE_URL', 'https://api.ibacpro.com/api')
  .constant('API_BASE_URL_WITHOUT_API', 'https://api.ibacpro.com')
  .constant('API_VERSION', 1)
  .constant('OAUTH_BASE_URL', 'https://api.ibacpro.com/oauth')

  .constant('AUTH_LOCALSTORAGE_KEY', 'bribac.auth')
  .constant('LOCALE_LOCALSTORAGE_KEY', 'bribac.locale')
  .constant('REMEMBER_ME_LOCALSTORAGE_KEY', 'bribac.remember')

  .constant('SEARCH_QUERY_MINLENGTH', 3)
  .constant('SEARCH_REULTS_PER_PAGE', 10)
  .constant('SMS_MAXLENGTH', 140)

  .constant('PASSWORD_VALIDATION_REGEX', /^[a-zA-Z0-9]{8,}$/)
  .constant('PHONE_NUMBER_REGEX', /^\s*\+[0-9\s]+$/)
  .constant('MAC_ADDRESS_REGEX', /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/)
  .constant('SSN_REGEX', /^\d+$/)
  .constant('TEXT_EXPIRATION_INTERVAL_REGEX',/^([5-9]|[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-9][0-9]|4[0-9][0-9]|5[0-9][0-9]|6[0-9][0-9]|7[0-2][0-0])$/)
  .constant('VERIFICATION_CODE_REGEX',/^[0-9]{6}$/)

  .constant('ROLES', {
    SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
    ADMIN: 'ROLE_ADMIN',
    GROUP_ADMIN: 'ROLE_GROUP_ADMIN',
    SUBJECT: 'ROLE_SUBJECT'
  })

  .constant('BAC_UNITS', {
    PERCENT: 'BAC_PERCENT',
    PER_MILLE: 'BAC_PER_MILLE',
    BRAC: 'BRAC'
  })

  .constant('TEST_STATE', {
    INACTIVE: 'INACTIVE',
    OPEN: 'OPEN',
    PASSED: 'PASSED',
    FAILED: 'FAILED',
    EXPIRED: 'EXPIRED'
  })

  .constant('PERMISSION', {
    CREATE_EDIT: 'createEdit',
    MANAGE_IBAC: 'manageIbac',
    MANAGE_ORGANIZATION: 'manageOrganization',
    DEACTIVATE_AGENT: 'deactivateAgent',
    MANAGE_INVOICE: 'manageInvoice',
    DELETE_IDENTITY: 'deleteIdentity'
  })

  .constant('DOCUMENTATION', {
    BASE_URL: 'https://docs.ibacpro.com/web-ui/production/',
    SUPER_ADMIN_HTML: 'web-ui-superadmin.html',
    ADMIN_HTML: 'web-ui.html',
    GROUP_ADMIN_HTML: 'web-ui.html',
  })

  .constant('US_STATES', [
    {code: 'AL', name: 'Alabama'},
    {code: 'AK', name: 'Alaska'},
    {code: 'AZ', name: 'Arizona'},
    {code: 'AR', name: 'Arkansas'},
    {code: 'CA', name: 'California'},
    {code: 'CO', name: 'Colorado'},
    {code: 'CT', name: 'Connecticut'},
    {code: 'DE', name: 'Delaware'},
    {code: 'FL', name: 'Florida'},
    {code: 'GA', name: 'Georgia'},
    {code: 'HI', name: 'Hawaii'},
    {code: 'ID', name: 'Idaho'},
    {code: 'IL', name: 'Illinois'},
    {code: 'IN', name: 'Indiana'},
    {code: 'IA', name: 'Iowa'},
    {code: 'KS', name: 'Kansas'},
    {code: 'KY', name: 'Kentucky'},
    {code: 'LA', name: 'Louisiana'},
    {code: 'ME', name: 'Maine'},
    {code: 'MD', name: 'Maryland'},
    {code: 'MA', name: 'Massachusetts'},
    {code: 'MI', name: 'Michigan'},
    {code: 'MN', name: 'Minnesota'},
    {code: 'MS', name: 'Mississippi'},
    {code: 'MO', name: 'Missouri'},
    {code: 'MT', name: 'Montana'},
    {code: 'NE', name: 'Nebraska'},
    {code: 'NV', name: 'Nevada'},
    {code: 'NH', name: 'New Hampshire'},
    {code: 'NJ', name: 'New Jersey'},
    {code: 'NM', name: 'New Mexico'},
    {code: 'NY', name: 'New York'},
    {code: 'NC', name: 'North Carolina'},
    {code: 'ND', name: 'North Dakota'},
    {code: 'OH', name: 'Ohio'},
    {code: 'OK', name: 'Oklahoma'},
    {code: 'OR', name: 'Oregon'},
    {code: 'PA', name: 'Pennsylvania'},
    {code: 'RI', name: 'Rhode Island'},
    {code: 'SC', name: 'South Carolina'},
    {code: 'SD', name: 'South Dakota'},
    {code: 'TN', name: 'Tennessee'},
    {code: 'TX', name: 'Texas'},
    {code: 'UT', name: 'Utah'},
    {code: 'VT', name: 'Vermont'},
    {code: 'VA', name: 'Virginia'},
    {code: 'WA', name: 'Washington'},
    {code: 'WV', name: 'West Virginia'},
    {code: 'WI', name: 'Wisconsin'},
    {code: 'WY', name: 'Wyoming'}
  ])

  .constant('CLAIMS', {
    VIRTUAL_INTERVENTION: {
      cptCode: 'H0050',
      event: 'VIRTUAL_INTERVENTION',
      name: 'ST-Patient Concern',
      description: 'Brief intervention in response to patient concern and contact',
    },
    REMOTE_PATIENT_MONITORING: {
      cptCode: '99458',
      event: 'REMOTE_PATIENT_MONITORING_20_MIN',
      name: 'ST-RPM 20 Min',
      description: 'Collaborate with subject to manage care plan, discuss testing, scheduling & treatment',
    },
    SOCIAL_COUNSELLING: {
      cptCode: 'H0029',
      event: 'SOCIAL_COUNSELLING',
      name: 'ST-Social Non-Alc',
      description: 'Provide social recreational activities, alternative activities, non-alcoholic',
    },
    GROUP_COUNSELLING: {
      cptCode: 'H0005',
      event: 'GROUP_COUNSELLING',
      name: 'PR-Group Counsel',
      description: '31 minutes of planned counseling activity - No social activity',
    },
    TREATMENT_PLAN: {
      cptCode: 'H0032',
      event: 'MENTAL_HEALTH_TREATMENT_PLAN',
      name: 'PR-Mental Health',
      description: 'Evaluate, develop and modify treatment plan',
    }
  })
